import NotFound from '@/components/NotFound/NotFound';
import { buildRouterConfiguration, RouteEntry } from '@/core/utils';
import { ReactElement } from 'react';
import { useRoutes } from 'react-router-dom';

interface AppRouterProps {
  routes: RouteEntry[];
  catchNotFound?: boolean;
}

export const RouterMap = ({
  routes,
  catchNotFound = true,
}: AppRouterProps): ReactElement | null => {
  const routesMapping = buildRouterConfiguration(routes);

  if (catchNotFound) {
    routesMapping.push({
      path: '*',
      element: <NotFound />,
    });
  }

  return useRoutes(routesMapping);
};
